import { Menu, MenuButton, MenuItems } from "@headlessui/react";

import { tw } from "~/utils";
import { Avatar } from "../Avatar";
import { UserDropdownNavigation } from "../Navigation";
import { UserInformation } from "../UserInformation";

interface ProfileDropdownProps {
  className?: string;
}

export const ProfileDropdown = ({ className }: ProfileDropdownProps) => {
  return (
    <Menu as="div" className={tw("relative", className)}>
      <MenuButton className="-m-1.5 flex items-center p-1.5">
        <span className="sr-only">Open user menu</span>
        <Avatar />
      </MenuButton>
      <MenuItems
        transition
        className="focus:outline-hidden data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in absolute right-0 z-10 mt-2.5 w-[280px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray-900/5 transition"
      >
        <UserInformation />

        <hr className="border-neutral-400" />

        <UserDropdownNavigation />
      </MenuItems>
    </Menu>
  );
};
